<template>
  <div class="article-detail-page">
    <div v-if="loading" class="loading-state">
      Loading article content...
    </div>
    
    <div v-else-if="article">
      <section class="hero">
        <div class="container">
          <div class="hero-content">
            <h1>{{ article.title }}</h1>
            <hr class="hero-divider" />
            <p class="hero-date">{{ article.date }}</p>
          </div>
        </div>
      </section>

      <section class="article-content">
        <div class="boundary-image-container" v-if="article.imageSrc">
          <img :src="getImage(article.imageSrc)" :alt="article.title" />
        </div>
        <div class="container">

          <div class="article-body">
            <div class="article-text" v-html="article.content"></div>
            <div class="back-to-articles">
              <button class="back-button" @click="goBack">← Back to Articles</button>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div v-else class="error-state">
      <p>Article not found.</p>
      <div class="back-to-articles">
        <button class="back-button" @click="goBack">← Back to Articles</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ArticleDetailPage',
  data() {
    return {
      article: null,
      loading: true
    };
  },
  mounted() {
    this.fetchArticle();
  },
  methods: {
    async fetchArticle() {
      const articleId = this.$route.params.id;
      try {
        const response = await axios.get(`/api/article/${articleId}`);
        this.article = response.data;
      } catch (error) {
        console.error('Failed to fetch article details:', error);
      } finally {
        this.loading = false;
      }
    },
    getImage(srcString){
      if (!srcString) return '';
      if (srcString.startsWith('/api/') || srcString.startsWith('http')) {
        return srcString;
      }
      const fileName = srcString.split('/').pop(); // Extract filename
      try{
        return require(`@/assets/images/${fileName}`);
      }
      catch(e){
        return srcString;
      }
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.loading-state, .error-state {
  padding: 10rem 0;
  text-align: center;
  font-size: 1.5rem;
  color: white;
  min-height: 50vh;
  background-color: #151414;
}

.hero {
  background-color: #617395;
  background-size: cover;
  background-position: center;
  color: white;
  padding: 8rem 0 16rem 0; /* 增大底部 padding 到 18rem，彻底解决图片遮挡问题 */
  text-align: left;
  position: relative;
  width: 100%;
}

.hero-divider {
  border: none;
  border-top: 1px solid #ffffff; 
  margin: 1.5rem 0 1rem 0; 
  width: 100%; 
}

.hero-date {
  font-size: 0.85rem; 
  color: rgba(255, 255, 255, 0.9);
  font-family: PingFangSC, Arial, sans-serif;
  letter-spacing: 0.5px; 
  margin: 0;
}
/*
.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(8, 8, 8, 0.6);
  z-index: 1;
}
*/
.hero-content {
  position: relative;
  z-index: 2;
  max-width: 1000px;
  margin: 0 auto;
  width: 90%;
  padding: 0;
}

.hero h1 {
  width: 395px;
  height: 60px;
  font-family: TimesNewRomanPSMT;
  font-size: 24px;
  color: #FFFFFF;
  line-height: 28px;
  letter-spacing: 5px;
  text-align: left;
  font-style: normal;
}

.article-content {
  position: relative;
  background-color: #ffffff;
  color: #111111;
  padding: 18rem 0 4rem 0; 
  width: 100%;
}

.boundary-image-container {
  position: absolute;
  top: 0; 
  left: 50%; 
  transform: translate(-50%, -50%); 
  z-index: 10;
  width: 90%; 
  max-width: 1000px; 
}

.boundary-image-container img {
  width: 100%;
  height: auto;
  aspect-ratio: 2 / 1; 
  object-fit: cover; 
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4); 
  display: block;
}

.article-body {
  margin: 0 auto;
  padding: 0 1.5rem;
  width: 900px;
  max-width: 100%;
}

.article-text {
  width: 900px;
  max-width: 100%;
  min-height: 1139px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 24px;
  color: #111111;
  line-height: 33px;
  text-align: left;
  font-style: normal;
}

.article-text p {
  margin-bottom: 2rem;
  padding-top: 1rem;
  text-align: left;
}

.back-to-articles {
  margin-top: 3rem;
  text-align: center;
  padding-top: 2rem;
  border-top: 1px solid #7a7575;
}

.back-button {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 25px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
}

.back-button:hover {
  background-color: var(--secondary-color);
}

@media (max-width: 768px) {
  .hero h1 {
    font-size: 2rem;
  }

  .article-content {
    padding-top: 12rem;
  }
  
  .meta {
    font-size: 1rem;
  }
  
  .article-body {
    padding: 0 1rem;
    width: 100%;
  }
  
  .article-text {
    font-size: 1rem;
    width: 100%;
    height: auto;
    min-height: auto;
  }
}
</style>